import { Navigate, Outlet } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { useEffect, useState } from "react";

export default function VendorAuthGuard() {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
  }, []);

  if (loading) return null; // later: spinner

  if (!session) {
    return <Navigate to="/vendor/login" replace />;
  }

  return <Outlet />;
}
